export default "__VITE_ASSET__CLeTBdhs__"